import { IDetalhePeriodoFerias } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IDetalhePeriodoFeriasState {
  data: IDetalhePeriodoFerias[];
  loading: boolean;
  error: string | null;
}

const initialState: IDetalhePeriodoFeriasState = {
  data: [] as IDetalhePeriodoFerias[],
  error: null,
  loading: false
};

export const detalhePeriodoFeriasSlice = createSlice({
  name: 'detalhePeriodoFerias',
  initialState,
  reducers: {
    detalhePeriodoFerias_fetching: (state) => {
      state.loading = true;
      state.data = [] as IDetalhePeriodoFerias[];
      state.error = null;
    },
    detalhePeriodoFerias_success: (state, action: PayloadAction<IDetalhePeriodoFerias[]>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    detalhePeriodoFerias_error: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.data = [] as IDetalhePeriodoFerias[];
    }
  }
});

export const { detalhePeriodoFerias_fetching, detalhePeriodoFerias_success, detalhePeriodoFerias_error } = detalhePeriodoFeriasSlice.actions;

export const selectorDetalhePeriodoFerias = (state: AppState) => state.detalhePeriodoFerias;

export default detalhePeriodoFeriasSlice.reducer;
